<!-- Modal Title -->
<ng-template [nzModalTitle]>
  <nz-row [nzGutter]="[16, 16]" class="mb-6">
    <nz-col [nzXs]="24" [nzMd]="24">
      <div class="flex justify-between items-center">
        <div class="flex items-center gap-4">
          <h2 class="text-lg font-semibold text-gray-800">Incident - {{ incident?.incident_id }}</h2>
          <div class="flex items-center gap-2 text-[12px] text-gray-600">
            <div>
              <i nz-icon nzType="calendar" nzTheme="outline" class="mr-1"></i>
              <span>{{incident.triggered_time | gDate:'MMM dd yyyy'}}</span>
            </div>
            <div>
              <i nz-icon nzType="clock-circle" nzTheme="outline" class="mr-1 ml-2"></i>
              <span>{{incident.triggered_time | gDate:'HH:mm:ss'}}</span>
            </div>
          </div>
        </div>
      </div>
    </nz-col>
  </nz-row>
</ng-template>

<!-- Modal Content -->
<div class="p-4 max-w-4xl">
  <!-- Asset and Location Details -->
  <nz-row [nzGutter]="[16, 16]">
    <!-- Details -->
    <nz-col [nzXs]="24" [nzMd]="10">
      <div class="p-4">
        <div class="flex items-start space-x-4">
          <div>
            <span style="font-size: 4rem !important;" nz-icon [nzType]="'hezky:SnowFlake'"></span>
          </div>
          <div class="flex flex-col">
            @if(!feUtil.roleService.hasRole('Security')) {
            <div class="flex items-center gap-x-2">
              <a class="text-primary font-medium flex flex-nowrap items-center max-w-[150px] truncate" (click)="modalRef.close()"
                [routerLink]="appId === 2 ? ['/trips/'+incident?.trip_id] : ['/assets', incident?.asset_id]">
                {{ appId === 2 ? 'Trip ID: '+incident?.trip_id : incident?.asset_name || 'N/A' }}
              </a>
              <app-severity-chip [severity]="incident?.severity"></app-severity-chip>
            </div>
            } @else {
            <span class="text-primary font-medium flex flex-nowrap items-center">
              {{ appId === 2 ? 'Trip ID: '+incident?.trip_id : incident?.asset_name || 'N/A' }}
              <app-severity-chip [severity]="incident?.severity"></app-severity-chip>
            </span>
            }
            <ng-container *ngIf="appId === 2">
              <div class="mt-2">
                <app-trip-route [locationData]="[
                              { location: incident?.startLocation?.name, type: 'leg' },
                              { location: incident?.endLocation?.name, type: 'leg' }]">
                </app-trip-route>
              </div>
            </ng-container>
            <div class="text-sm text-gray-600" *ngIf="appId == 1">{{ incident?.display_name }}</div>
            <div class="text-sm text-gray-400" *ngIf="appId == 1">{{ incident?.environment || 'N/A' }}</div>
          </div>
        </div>
      </div>
    </nz-col>
    <!-- Actions -->
    <nz-col [nzXs]="24" [nzMd]="14">
      <div class="p-4">
        <nz-row [nzGutter]="[16, 16]">
          <nz-col [nzXs]="24" [nzMd]="12">
            <label class="text-xs text-primary font-medium mb-1 block">Assigned User</label>
            <nz-select class="w-full" [(ngModel)]="incident.assigned_to" nzShowSearch nzPlaceHolder="Not Assigned"
              [nzDisabled]="feUtil.roleService.hasAccess([3,4]) || (incident?.leg_status && incident?.leg_status !== 'completed')" (ngModelChange)="handleAssignTo($event)">
              <nz-option *ngFor="let user of users" [nzValue]="user.user_id" [nzLabel]="user.username">
              </nz-option>
            </nz-select>
          </nz-col>
          <nz-col [nzXs]="24" [nzMd]="12">
            <button nz-button nzType="default" class="w-full mt-5" (click)="handleAcknowledge()"
              [ngClass]="{'bg-success text-white hover:bg-success/80 hover:text-white focus:bg-success/80 focus:text-white disabled:bg-success disabled:text-white ': incident?.acknowledged}"
              [disabled]="incident?.acknowledged === true || feUtil.roleService.hasAccess([3,4])">
              <i nz-icon nzType="check" nzTheme="outline"></i>
              {{incident.acknowledged === null || incident.acknowledged === false ? 'Acknowledge' : 'Acknowledged' }}
            </button>
          </nz-col>
        </nz-row>
      </div>
    </nz-col>
  </nz-row>
  <nz-divider class="my-1"></nz-divider>
  <!-- Temperature Alert Section -->
  <nz-row [nzGutter]="[16, 16]">
    <nz-col [nzXs]="24" [nzMd]="24">
      <div class="p-6">
        <nz-row [nzGutter]="[16, 16]">
          <nz-col [nzXs]="24" [nzMd]="8">
            <div class="flex flex-nowrap items-center">
              <ng-container *ngIf="incident?.incident_type && incident?.severity">
                <i [nzTooltipColor]="'#fff'"
                  [ngClass]="feUtil.getSeverityColor(incident?.severity)"
                  [nz-tooltip]="incident.incident_type" nz-icon
                  [nzType]="'hezky:'+incident?.incident_type" class="mr-1 mt-1  text-4xl">
                </i>
              </ng-container>
              <h3 *ngIf="incident?.incident_type && appId == 1" class="text-4xl font-medium" [ngClass]="feUtil.getSeverityColor(incident?.severity)">
                {{feUtil.getFormattedTemp(incident.current_alarm,incident?.incident_type?.toLowerCase())}}
              </h3>
              <h3 *ngIf="incident?.incident_type && appId == 2" class="text-4xl font-medium" [ngClass]="feUtil.getSeverityColor(incident?.severity)">
                {{feUtil.getFormattedTemp(incident.triggered_value,incident?.incident_type?.toLowerCase())}}
              </h3>
            </div>
          </nz-col>
          <nz-col [nzXs]="24" [nzMd]="16">
            <p class="font-medium mt-1" [ngClass]="feUtil.getSeverityColor(incident?.severity)">{{incident.incident_name}}</p>
            <p class="text-gray-600 text-sm mt-0">
              <span>{{incident?.threshold_condition}}</span>
              <span class="mx-2 border-r border-gray-300 pr-2">{{ feUtil.getFormattedTemp(incident?.threshold_value, incident?.incident_type?.toLowerCase())}}</span>
              <span>{{ 'Duration: ' + (incident?.triggered_time | relativeTime:'modal') }}</span>
            </p>
          </nz-col>
        </nz-row>
      </div>
    </nz-col>
  </nz-row>
  <nz-divider class="my-1"></nz-divider>
  <!-- Incident Logs Section -->
  <nz-row [nzGutter]="[16, 16]">
    <nz-col [nzXs]="24" [nzMd]="24">
      <div class="py-2">
        <h4 class="text-gray-700 font-medium mb-4">Incident Logs</h4>
        <nz-spin [nzSpinning]="loaders['isIncidentLogsLoading']">
          <nz-timeline class="horizontal-timeline">
            <ng-container *ngFor="let log of logs; trackBy: feUtil.trackByFn">
              <nz-timeline-item
                [nzColor]="log.status === 'CLOSED' ? '#28A745' : log.severity === 'High' ? '#E60707' : log.severity === 'Medium' ? '#D97706' : '#E9AA06'">
                <div class="text-sm text-gray-800 flex flex-col items-start">
                  <div class="flex items-center gap-x-2">
                    <div>
                      <span nz-icon nzType="calendar" nzTheme="outline" class="text-gray-400 text-xs"></span>
                      <span class="text-xs text-gray-600 font-medium">
                        {{ (log?.time || log?.createdat) | gDate:'dd MMM yyyy' }}
                      </span>
                    </div>
                    <div>
                      <span nz-icon nzType="clock-circle" nzTheme="outline" class="text-gray-400 text-xs"></span>
                      <span class="text-xs text-gray-600 font-medium">
                        {{ (log?.time || log?.createdat) | gDate:'HH:mm:ss'}}
                      </span>
                    </div>
                  </div>
                  <span class="text-xs text-gray-600 font-medium">{{ log?.description || log?.log }}</span>
                </div>
              </nz-timeline-item>
            </ng-container>
          </nz-timeline>
          <ng-template #noLogs>
            <div class="h-[300px] w-full place-content-center">
              <nz-empty class="text-danger" [nzNotFoundContent]="'No logs found!'"></nz-empty>
            </div>
          </ng-template>
        </nz-spin>
      </div>
    </nz-col>
  </nz-row>
</div>

<!-- Footer Buttons -->
<ng-template [nzModalFooter]>
  <div class="flex justify-between" *ngIf="!feUtil.roleService.hasRole('Security')">
    <button [routerLink]="appId == 1 ? ['/storage-incidents/list'] : ['/transport-incidents/list']" nz-button type="button" (click)="modalRef.close()"
      class="bg-primary text-white hover:bg-primary-hover border-none hover:text-white">
      All Incidents
    </button>
    <button *ngIf="!feUtil.roleService.hasRole('Security')"
      [routerLink]="appId == 1 ? ['/storage-incidents/list/'+incident?.incident_id] : ['/transport-incidents/list/'+incident?.leg_id]" nz-button type="button"
      (click)="modalRef.close()" class="bg-primary text-white hover:bg-primary-hover hover:text-white">
      View Incident Details
    </button>
  </div>
</ng-template>